import { render } from "./CreateNewCard.vue?vue&type=template&id=d34585b4&scoped=true"
import script from "./CreateNewCard.vue?vue&type=script&lang=js"
export * from "./CreateNewCard.vue?vue&type=script&lang=js"

import "./CreateNewCard.vue?vue&type=style&index=0&id=d34585b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d34585b4"]])

export default __exports__